var React = require('react');

function IcStarOutlined (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M21.6834 11.2L33.6667 12.2334L24.5834 20.1167L27.3 31.8334L17 25.6167L6.70004 31.8334L9.43337 20.1167L0.333374 12.2334L12.3167 11.2167L17 0.166687L21.6834 11.2ZM10.7334 26.2834L17 22.5L23.2834 26.3L21.6167 19.1667L27.15 14.3667L19.85 13.7334L17 7.00002L14.1667 13.7167L6.86671 14.35L12.4 19.15L10.7334 26.2834Z","fill":"#181919"}));
}

IcStarOutlined.defaultProps = {"width":"34","height":"32","viewBox":"0 0 34 32","fill":"none"};

module.exports = IcStarOutlined;

IcStarOutlined.default = IcStarOutlined;
